module.exports = __webpack_public_path__ + "img/tasks.9ed778df.svg";